var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contract" },
    [
      _c(
        "el-drawer",
        {
          attrs: {
            "append-to-body": true,
            "before-close": _vm.handleClose,
            direction: _vm.direction,
            modal: true,
            "modal-append-to-body": false,
            "show-close": true,
            size: _vm.formData.width,
            title: _vm.formData.title,
            visible: _vm.drawer,
            "wrapper-closable": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "invoice-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c(
                "el-row",
                { staticClass: "invoice-header" },
                [
                  _c("el-col", { staticClass: "invoice-left" }, [
                    _c("div", { staticClass: "invoice-logo" }, [
                      _c("i", { staticClass: "icon iconfont iconhetong" }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.drawer
                    ? _c("el-col", { staticClass: "invoice-right" }, [
                        _c("div", { staticClass: "txt1 over-text" }, [
                          _vm._v(_vm._s(_vm.formData.data.contract_name)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "txt2" }, [
                          _c("span", { staticClass: "title" }, [
                            _vm._v("合同状态："),
                          ]),
                          _c("span", { style: { color: _vm.activeColor } }, [
                            _vm._v(
                              _vm._s(
                                _vm.getStatus(_vm.dataInfo.contract_status)
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "title" }, [
                            _vm._v("合同金额(元)："),
                          ]),
                          _c("span", { staticClass: "info1" }, [
                            _vm._v("¥" + _vm._s(_vm.dataInfo.contract_price)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.$t("customer.customer")) + "："),
                          ]),
                          _c("span", { staticClass: "weight" }, [
                            _vm._v(
                              _vm._s(
                                _vm.dataInfo.contract_customer
                                  ? _vm.dataInfo.contract_customer.customer_name
                                  : "--"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "title" }, [
                            _vm._v(" 业务员："),
                          ]),
                          _c("span", { staticClass: "weight" }, [
                            _vm._v(
                              _vm._s(
                                _vm.dataInfo.salesman
                                  ? _vm.dataInfo.salesman.name
                                  : "--"
                              )
                            ),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.tabData.length
            ? _c(
                "el-tabs",
                {
                  attrs: {
                    "tab-position": _vm.tabPosition,
                    type: "border-card",
                  },
                  on: { "tab-click": _vm.handleClick },
                  model: {
                    value: _vm.tabIndex,
                    callback: function ($$v) {
                      _vm.tabIndex = $$v
                    },
                    expression: "tabIndex",
                  },
                },
                _vm._l(_vm.tabData, function (item) {
                  return _c("el-tab-pane", {
                    key: item.value,
                    attrs: { label: item.label, name: item.value },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "contract-body table-box mt14" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber === 1,
                    expression: "tabNumber === 1",
                  },
                ],
                staticClass: "contract-info",
              },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "invoice-body",
                    attrs: { "label-width": "auto" },
                  },
                  _vm._l(_vm.dataInfo.list, function (item, index) {
                    return _c("div", { key: index }, [
                      _c("div", { staticClass: "from-item-title mb15" }, [
                        _c("span", [_vm._v(_vm._s(item.title))]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-box" },
                        _vm._l(item.data, function (value, key) {
                          return _c(
                            "div",
                            {
                              key: key,
                              staticClass: "form-item",
                              class:
                                value.type !== "file" && value.type !== "image"
                                  ? ""
                                  : "oneline",
                            },
                            [
                              value.type == "file" || value.type == "image"
                                ? _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_vm._v(_vm._s(value.key_name) + ":")]
                                      ),
                                      _vm._v(" "),
                                      value.files && value.files.length > 0
                                        ? _c("upload-file", {
                                            staticClass: "upload-file",
                                            attrs: {
                                              "file-list": value.files,
                                              fileWidth: "300px",
                                              url: "/system/attach/upload",
                                            },
                                          })
                                        : _c("span", [_vm._v("--")]),
                                    ],
                                    1
                                  )
                                : value.type == "oaWangeditor"
                                ? _c(
                                    "el-form-item",
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: { slot: "label" },
                                          slot: "label",
                                        },
                                        [_vm._v(_vm._s(value.key_name) + ":")]
                                      ),
                                      _vm._v(" "),
                                      _c("ueditor-from", {
                                        ref: "ueditorFrom",
                                        refInFor: true,
                                        attrs: {
                                          border: true,
                                          content: value.value,
                                          height: "400px",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("el-form-item", [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "label" },
                                        slot: "label",
                                      },
                                      [_vm._v(_vm._s(value.key_name) + ":")]
                                    ),
                                    _vm._v(" "),
                                    _c("p", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.getValue(value.value)
                                        ),
                                      },
                                    }),
                                  ]),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "line" }),
                    ])
                  }),
                  0
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber === 2,
                    expression: "tabNumber === 2",
                  },
                ],
                staticClass: "contract-list",
              },
              [
                _c("contract-payment", {
                  ref: "contractPayment",
                  attrs: { "form-info": _vm.formData },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber === 6,
                    expression: "tabNumber === 6",
                  },
                ],
                staticClass: "contract-list",
              },
              [
                _c("contract-renew", {
                  ref: "contractRenew",
                  attrs: { "form-info": _vm.formData },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber === 3,
                    expression: "tabNumber === 3",
                  },
                ],
                staticClass: "contract-list",
              },
              [
                _c("contract-remind", {
                  ref: "contractRemind",
                  attrs: { "form-info": _vm.formData },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.tabNumber === 4,
                    expression: "tabNumber === 4",
                  },
                ],
                staticClass: "contract-list",
              },
              [
                _c("contract-invoice", {
                  ref: "contractInvoice",
                  attrs: {
                    contractInvoice: _vm.contractInvoice,
                    "form-info": _vm.formData,
                  },
                  on: { handleInvoice: _vm.handleInvoice },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.tabNumber === 5
              ? _c(
                  "div",
                  { staticClass: "contract-list" },
                  [
                    _c("file", {
                      ref: "file",
                      attrs: { "form-info": _vm.formData },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("edit-customer", {
        ref: "editCustomer",
        attrs: { "form-data": _vm.newForm },
        on: {
          isOkEdit: function ($event) {
            return _vm.getTableData(true)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }